import { createRoot } from 'react-dom/client';
import { IsuraApplication } from './isura_application';

createRoot(document.getElementById('root')!).render(<IsuraApplication />);
